@if (cellData()) {
	<div class="sh-progress-cell">
		<div class="progress-container">
			@switch (cellData()?.status) {
				@case (progressStatusEnum.InProgress) {
					<prism-progress-indicator data-testid="sh-progress-spinner" class="spinner-icon" type="circular" />
				}
				@case (progressStatusEnum.Success) {
					<prism-icon
						data-testid="sh-progress-success-icon"
						class="status-icon success-state"
						icon="check_circle"
					/>
				}
				@case (progressStatusEnum.Error) {
					<prism-icon
						data-testid="sh-progress-error-icon"
						class="status-icon error-state"
						icon="report_gmailerrorred"
					/>
				}
			}

			@if (cellData()?.statusTextKey) {
				<span data-testid="sh-progress-status-msg">{{ cellData()?.statusTextKey | transloco }}</span>
			}
		</div>
	</div>
}
